import { PATH_ARTICLES, PATH_DEMO } from '@/constants/spa-routes';
import Header from 'src/components/Header/Header';
import Head from 'next/head';
import Script from 'next/script';
import Footer from 'src/components/Footer/Footer';
import { Typography } from 'src/components/Typography/Typography';
import { COLORS } from '@/constants/colors';
import { GreenButton } from '@/components/ButtonsCollection/GreenButton/GreenButton';

type NonExistedArticleProps = {
  originUrl: string;
};

export const NonExistedArticle = ({ originUrl }: NonExistedArticleProps) => {
  return (
    <>
      <Head>
        <meta key="viewport" name="viewport" content="initial-scale=1.0, width=device-width" />
        <title>CoSupport AI</title>
        <meta key="subject" name="subject" content={'CoSupport AI'} />
        <meta key="description" name="description" content={'CoSupport AI'} />
        <meta key="ogtitle" property="og:title" content={'CoSupport AI'} />
        <meta key="ogtype" property="og:type" content="website" />
        <meta key="oglocale" property="og:locale" content="en_US" />
        <meta
          key="ogimage"
          property="og:image"
          content={`${originUrl}/img/open-graph/articles-page.png`}
        />
        <meta key="ogsitename" property="og:site_name" content={`${originUrl}/`} />
        <meta key="ogdescription" property="og:description" content="CoSupport AI" />
        <Script
          id="googletagmanager3"
          key="googletagmanager3"
          strategy="beforeInteractive"
          src="https://www.googletagmanager.com/gtag/js?id=AW-11237889467"
        />
        <Script
          id="googletagmanager4"
          key="googletagmanager4"
          strategy="lazyOnload"
          dangerouslySetInnerHTML={{
            __html: `
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
          gtag('config', 'AW-11237889467');
      `,
          }}
        />
        <Script
          id="googletagmanager5"
          key="googletagmanager5"
          strategy="lazyOnload"
          dangerouslySetInnerHTML={{
            __html: `
        (function (w, d, s, l, i) {
        w[l] = w[l] || [];
        w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
        var f = d.getElementsByTagName(s)[0],
          j = d.createElement(s),
          dl = l != 'dataLayer' ? '&l=' + l : '';
        j.async = true;
        j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
        f.parentNode.insertBefore(j, f);
      })(window, document, 'script', 'dataLayer', 'GTM-WXHFTKL9');
      `,
          }}
        />
      </Head>
      <Header pathname={`${PATH_ARTICLES.ROOT}`} />
      <main className="!pb-0 h-[100vh] flex items-center justify-center">
        <div className="flex flex-col items-center justify-center h-full gap-[30px] max-w-[600px]">
          <Typography
            $color={COLORS.EBONY}
            $type="Heading1"
            $weight="700"
            className="font-formula text-center"
          >
            Non-existent article
          </Typography>
          <Typography $type="PMedium" $weight="400" className="text-center">
            Sorry, but there is no such article on our website. However, we have plenty of other
            useful information.
          </Typography>
          <GreenButton url={PATH_ARTICLES.ROOT}>
            <span>Go To Articles</span>
          </GreenButton>
        </div>
      </main>
      <Footer />
    </>
  );
};
